import * as moment from "moment";
import {TransactionEventApiDto} from "../../../api/model/rest";
import AuthenticatedEntity from "../../user/AuthenticatedEntity";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import TransactionEvent, {TransactionEventTypeEnum} from "./TransactionEvent";
import {TransactionEventData} from "./TransactionPaymentReceivedEvent";
import {none, option, Option} from "ts-option";

/**
 * Transaction - payment reconciled event model.
 */
export default class TransactionPaymentReconciledEvent extends TransactionEvent {
	/**
	 * @param {string} id identifier of event.
	 * @param {TransactionEventTypeEnum} type type of the event.
	 * @param {AuthenticatedEntity} creator entity which created the event.
	 * @param {moment.Moment} creationDateTime creation date of event.
	 * @param {Option<TransactionEventData>} data additional data for this event.
	 */
	constructor(public readonly id: string,
		public readonly type: TransactionEventTypeEnum,
		public readonly creator: AuthenticatedEntity,
		public readonly creationDateTime: moment.Moment,
		public readonly data: Option<TransactionEventData>) {
		super(id, type, creator, creationDateTime);
	}

	public static fromJson(json: TransactionEventApiDto): TransactionPaymentReconciledEvent {
		const creator = AuthenticatedEntity.fromJson(json.creator);
		const data = json.data ? option(TransactionEventData.fromJson(json.data)) : none;
		return new TransactionPaymentReconciledEvent(json.id, TransactionEventTypeEnum.PaymentReconciled, creator,
			moment(json.creationDateTime), data);
	}

	getIcon() {
		return Icon.CheckMark;
	}

	getActivityType(): string {
		return `RECONCILED`;
	}

	getActivityMessage(): string {
		const paymentId = this.data.map(d => d.stripePaymentId);
		return `Payment ${paymentId.map(id => `ID ${id} `).getOrElse("")}reconciled`;
	}
}
